import { render } from "./TopbarArena.vue?vue&type=template&id=13cacb9c"
import script from "./TopbarArena.vue?vue&type=script&lang=js"
export * from "./TopbarArena.vue?vue&type=script&lang=js"
script.render = render

export default script